<style lang="less" scoped>
    #qrcode_wrap {
        width: 190px;
        height: 190px;
        margin: 0 auto;
        overflow: hidden;
        img{
            margin: 0 auto;
            vertical-align: middle;
            width: 100%;
            height: 100%;
        }
    }
    @media screen and (max-width: 500px) {
        #qrcode {
            img{
                width: 95%;
                height: 95%;
            }
        }
    }
</style>
<template>
    <div id="qrcode_wrap" ref="qrcode_wrap">
        <img :src="httpQrcodesrc" alt="微信二维码" v-if="code" width="100%" height="100%">
    </div>
</template>
<script>
import QRCode from "qrcodejs2"
export default {
    props:['code'],
    name: "qrcode",
    data() {
        return {
            qrcodeStatus: true,
            qrcodeBaseCode: '',  //base64转码后的票号
            httpQrcodesrc: ''      //网络地址
        }
    },
    mounted() {
      console.log(this.code,'this.code')
        this.$nextTick(()=>{
            // this.qrcodeHome()
            if(this.code != null){
            	this.qrcodeBaseCode = this.encode(this.code); //对票号进行base64编码
	            console.log(this.qrcodeBaseCode);
	            this.httpQrcodesrc = "https://ssr.ourwill.cn/qrcode/png/"+ this.qrcodeBaseCode +".png?s=6"
	            console.log(this.httpQrcodesrc);
            }
        })
    },
    methods:{
        encode(input) {   //编码方法
            var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var output = "";
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;
            input = this._utf8_encode(input);
            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output +
                _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
            }
            return output;
        },
        _utf8_encode(string) {
            string = string.replace(/\r\n/g,"\n");
            var utftext = "";
            for (var n = 0; n < string.length; n++) {
                var c = string.charCodeAt(n);
                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        }
    },
    watch:{
    	code(newValue){
            console.log(newValue);
    		this.qrcodeBaseCode = this.encode(newValue);
    		console.log(this.qrcodeBaseCode);
            this.httpQrcodesrc = "https://ssr.ourwill.cn/qrcode/png/"+ this.qrcodeBaseCode +".png?s=6"
            console.log(this.httpQrcodesrc);
    	}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/qrcode.vue